const URL = {
    // 交易系统
    // "JYXT": "http://ythpt.sg.gov.cn/",
    "JYXT": "https://ygp.gdzwfw.gov.cn/ggzy-yhzx/",
    // 网上办事
    "WSBS": "https://wsbs.sg.gov.cn/",
    // 政声传递
    "ZSCD": "http://www.gd.gov.cn/xxts/",
    // 中介服务超市
    "ZJFWCS": "https://zjcs.sg.gov.cn/portal/zjcs/index.action",
    // 全国公共资源交易平台
    "QGGGZYJYPT": "http://www.ggzy.gov.cn/",
    // 广东省公共资源交易中心
    "GDSGGZYJYZX": "http://ggzy.gd.gov.cn/",
    // 韶关市人民政府
    "SGSRMZF": "https://www.sg.gov.cn/",
    // 广州产权交易所韶关分所
    "GZCQJYSSGFS": "http://sg.gemas.com.cn",

    // 市直属部门网站
    // 韶关市发展和改革局
    "SGSFZHGGJ": "http://fgj.sg.gov.cn",
    // 韶关市住房和城乡建设局
    "SGSZFHCXJSJ": "http://zgj.sg.gov.cn/",
    // 韶关市水务局
    "SGSSWJ": "http://water.sg.gov.cn/",
    // 韶关市交通运输局
    "SGSJTYSJ": "https://www.sg.gov.cn/bmpdlm/sgsjtysj/tzgg/",

    //国土资源交易过程信息
    "GTZYJYGCXX": "http://gtzy.jyzx.sg.gov.cn/",
    // 河砂权交易过程信息
    "HSQJYGCXX": "http://hsjy.jyzx.sg.gov.cn/",
    // 河砂权 专家评审
    "HSQZJPS": "http://hsjy.jyzx.sg.gov.cn/expertlogin",

    "API": process.env.VUE_APP_API_URL,
};

export default URL;